/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MDIStrictHttpResponse } from '../../mdi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyListModel } from '../../models/key-list-model';
import { KeyValueCodeModel } from '../../models/key-value-code-model';

export interface MasterDataServiceTypeLookupByKeyPost$Params {
      body?: KeyListModel
}

export function masterDataServiceTypeLookupByKeyPost(http: HttpClient, rootUrl: string, params?: MasterDataServiceTypeLookupByKeyPost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueCodeModel>>> {
  const rb = new RequestBuilder(rootUrl, masterDataServiceTypeLookupByKeyPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MDIStrictHttpResponse<Array<KeyValueCodeModel>>;
    })
  );
}

masterDataServiceTypeLookupByKeyPost.PATH = '/MasterData/ServiceTypeLookupByKey';
